
import Vue from 'vue';
import Icon from '~/components/builders/Base/Icon.vue';
import { Employer } from '~/services/types/candidate';

// Types
import { commonProps } from '~/utils/candidate';
import JobPreferencesModal from '../modals/JobPreferencesModal.vue';

// Components
import Card from './Card.vue';

export default Vue.extend({
    name: 'JobPreferences',
    components: { Card, JobPreferencesModal, Icon },
    props: {
        ...commonProps(),
        highlightIfRequiredFields: {
            type: Boolean,
            default: () => false,
            required: false,
        },
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        hasNoJobPreferences(): boolean {
            return (
                !this.candidate.preferences ||
                ((!this.candidate.preferences.sectors ||
                    !this.candidate.preferences.sectors.length) &&
                    (!this.candidate.preferences.sectors ||
                        !this.candidate.preferences.sectors.length) &&
                    (!this.candidate.preferences.employers ||
                        !this.candidate.preferences.employers.length) &&
                    (!this.candidate.preferences.careerFields ||
                        !this.candidate.preferences.careerFields.length))
            );
        },
        emptyRequiredFields(): boolean {
            return (
                this.highlightIfRequiredFields && !this.candidate?.preferences?.careerFields?.length
            );
        },
        cardTitle(): string {
            return this.hasNoJobPreferences
                ? this.$t('profile.jobPreferences.titleWhenEmpty').toString()
                : this.$t('profile.jobPreferences.title').toString();
        },
        employersToRender(): Employer[] {
            if (
                !(
                    this.candidate.preferences.preferredEmployers &&
                    this.candidate.preferences.employers
                )
            )
                return [];

            return this.candidate.preferences.preferredEmployers
                .map(employerId => {
                    const employer = this.candidate.preferences.employers!!.find(
                        employer => employer.id === employerId
                    );
                    return employer;
                })
                .filter(e => e) as Employer[];
        },
    },
});
